<page-toolbar [pageActions]="pageActions"
              title="{{'contact.' + type | translate}}: {{!itemId ? ('dynamicContent.create' | translate) : content?.title}}">
</page-toolbar>
<page-content>
  <mat-card appearance="outlined" *ngIf="!!content" class="contact">
    <mat-card-content>
      <h2>{{type === 'contact' ? ('contact.contactTitle' | translate ) : ('contact.addressTitle' | translate)}}</h2>
      <div class="input-container">
        <mat-form-field>
          <input [(ngModel)]="content.title" matInput required placeholder="{{'contact.title' | translate}}">
        </mat-form-field>
        <ng-container *ngIf="type === 'address'">
          <mat-form-field>
            <input [(ngModel)]="content.street" matInput placeholder="{{'contact.street' | translate}}">
          </mat-form-field>
          <mat-form-field>
            <input [(ngModel)]="content.zip" matInput placeholder="{{'contact.zip' | translate}}">
          </mat-form-field>
          <mat-form-field>
            <input [(ngModel)]="content.city" matInput placeholder="{{'contact.city' | translate}}">
          </mat-form-field>
          <ng-container *ngIf="content?.coordinates && content?.coordinates?.latitude && content?.coordinates?.longitude">
            <mat-form-field>
              <input [(ngModel)]="content.coordinates.latitude" matInput placeholder="{{'contact.lat' | translate}}" type="number">
            </mat-form-field>
            <mat-form-field>
              <input [(ngModel)]="content.coordinates.longitude" matInput placeholder="{{'contact.lng' | translate}}" type="number">
            </mat-form-field>
          </ng-container>
        </ng-container>
        <ng-container *ngIf="type === 'contact'">
          <mat-form-field>
            <input [(ngModel)]="content.email" matInput placeholder="{{'contact.email' | translate}}">
          </mat-form-field>
          <mat-form-field>
            <input [(ngModel)]="content.phone" matInput placeholder="{{'contact.phone' | translate}}">
          </mat-form-field>
          <mat-form-field>
            <input [(ngModel)]="content.fax" matInput placeholder="{{'contact.fax' | translate}}">
          </mat-form-field>
          <mat-form-field>
            <input [(ngModel)]="content.website" matInput placeholder="{{'contact.website' | translate}}">
          </mat-form-field>
        </ng-container>

      </div>
    </mat-card-content>
  </mat-card>
</page-content>
